import { LoginResponse } from '@/auth/interface/auth.interface';
import { ApprovalsService } from '@/services/approvals/approvals.service';
import { StoreState } from '@/store';
import { getCurrentUserData } from '@/store/login/selectors';
import { Component, OnInit } from '@angular/core';
import { Store } from '@ngrx/store';

@Component({
  selector: 'app-approver',
  templateUrl: './approver.component.html',
  styleUrls: ['./approver.component.css'],
})
export class ApproverComponent implements OnInit {

  requestApproverPendingReview: number = 0
  show0 = true;
  show1 = true;
  show2 = true;

  userData: Partial<LoginResponse> = {};

  constructor(
    private serviceApprover: ApprovalsService,
    private store: Store<StoreState>,
  ) {
    getCurrentUserData(this.store).subscribe({
      next: (userData) => {
        this.userData = userData;
      },
    });
  }

  ngOnInit(): void {
    this.getActivitiesTask();
  }

  toggle(id: number) {
    switch (id) {
      case 0: {
        this.show0 = !this.show0;
        break;
      }
      case 1: {
        this.show1 = !this.show1;
        break;
      }
      case 2: {
        this.show2 = !this.show2;
        break;
      }
      default:
        break;
    }
  }

  getActivitiesTask() {
    if (this.userData.mdmid) {
      this.serviceApprover.getTotalRequestApprovalCount(this.userData.mdmid)
        .subscribe((res) => {
          this.requestApproverPendingReview = res;
        });
    }
  }
}
